<!-- eslint-disable pct-custom-ng-rules/no-mat-icon-svg-icon -->
<header>
  <div #focusResetTarget id="focus-trap" tabindex="-1"></div>
  <div class="container-fluid-wide container-header">
    <div class="header-navs">
      <a href="#">
        <img
          alt="szebit logó"
          height="52"
          id="nav-logo"
          src="multimedia/header/szebit_logo_120.webp"
          width="96"
        />
      </a>
      <!-- desktop menu -->
      <nav *appShowOnDesktop aria-label="Főmenü" id="nav_menu" role="navigation">
        <div
          *appHasAccess="'Admin'"
          aria-haspopup="true"
          aria-label="Admin"
          class="subnav"
          role="menuitem"
          tabindex="0"
        >
          <div class="subnavbtn" tabindex="-1"
            >Admin <mat-icon svgIcon="pct-mdi-chevron-left"
          /></div>
          <div class="subnav-content">
            <div aria-haspopup="true" class="subnav-item-with-submenu" role="menuitem" tabindex="0">
              <div class="subnav-item-label">
                Felhasználók
                <mat-icon class="submenu-arrow" svgIcon="pct-mdi-chevron-right" />
              </div>
              <div class="subnav-level-3">
                <a
                  *appHasAccess="'SuperAdmin'"
                  role="menuitem"
                  routerLink="/admin/admins"
                  (click)="onSubmenuItemClick()"
                  >Adminok listája</a
                >
                <a role="menuitem" routerLink="/admin/users" (click)="onSubmenuItemClick()"
                  >Regisztráltak listája</a
                >
              </div>
            </div>
            <ng-container *appHasAccess="'SuperAdmin'">
              <a role="menuitem" routerLink="/admin/auditors" (click)="onSubmenuItemClick()"
                >Előadók listája</a
              >
              <a role="menuitem" routerLink="/admin/partners" (click)="onSubmenuItemClick()"
                >Partnerek listája</a
              >
              <div
                aria-haspopup="true"
                class="subnav-item-with-submenu"
                role="menuitem"
                tabindex="0"
              >
                <div class="subnav-item-label">
                  Események
                  <mat-icon class="submenu-arrow" svgIcon="pct-mdi-chevron-right" />
                </div>
                <div class="subnav-level-3">
                  <a role="menuitem" routerLink="/admin/programs" (click)="onSubmenuItemClick()"
                    >Események listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/workshop-applications"
                    (click)="onSubmenuItemClick()"
                    >Kerekasztal-beszélgetésre jelentkezések listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/seminar-applications"
                    (click)="onSubmenuItemClick()"
                    >Szemináriumra jelentkezések listája</a
                  >
                </div>
              </div>
              <div
                aria-haspopup="true"
                class="subnav-item-with-submenu"
                role="menuitem"
                tabindex="0"
              >
                <div class="subnav-item-label">
                  Játék és stand
                  <mat-icon class="submenu-arrow" svgIcon="pct-mdi-chevron-right" />
                </div>
                <div class="subnav-level-3">
                  <a
                    role="menuitem"
                    routerLink="/admin/exhibition-stands"
                    (click)="onSubmenuItemClick()"
                    >Standok listája</a
                  >
                  <a role="menuitem" routerLink="/admin/players" (click)="onSubmenuItemClick()"
                    >Játékosok listája</a
                  >
                </div>
              </div>
              <a
                role="menuitem"
                routerLink="/admin/push-notifications"
                (click)="onSubmenuItemClick()"
                >Értesítések listája</a
              >
              <a role="menuitem" routerLink="/admin/map" (click)="onSubmenuItemClick()"
                >Térkép szerkesztése</a
              >
              <a role="menuitem" routerLink="/admin/gala-dinner" (click)="onSubmenuItemClick()"
                >Gálavacsora szerkesztése</a
              >
            </ng-container>
            <a role="menuitem" routerLink="/admin/qrcode-checker" (click)="onSubmenuItemClick()"
              >QR kód beolvasása</a
            >
          </div>
        </div>
        <div aria-haspopup="true" aria-label="Főmenü" class="subnav" role="menuitem" tabindex="0">
          <div class="subnavbtn" href="#" tabindex="-1"
            >Kezdőoldal <mat-icon svgIcon="pct-mdi-chevron-left"
          /></div>
          <div class="subnav-content">
            <a href="#what-is-szebit" role="menuitem">Mi a SZEBIT?</a>
            <a href="#the-host" role="menuitem">A házigazda</a>
            <a href="#exhibitors" role="menuitem">Kiállítók és Partnerek</a>
            <a href="#galleries" role="menuitem">Galériák</a>
          </div>
        </div>
        <a role="menuitem" routerLink="/auditors">Előadók</a>
        <a href="#programs" role="menuitem">Programfüzet</a>
        <!--<a role="menuitem" routerLink="map" (click)="onSubmenuItemClick()">Térkép</a>
        <a role="menuitem" routerLink="game" (click)="onSubmenuItemClick()">Játék</a>-->
        <a
          *appHasAccess="'VipGold'"
          role="menuitem"
          routerLink="gala-dinner"
          (click)="onSubmenuItemClick()"
          >Gálavacsora</a
        >
        <a *appShowIfLoggedIn="false" role="menuitem" routerLink="/registration">Regisztráció</a>
        <a
          *appShowIfLoggedIn="false"
          href="#"
          role="menuitem"
          routerLink="/login"
          skipLocationChange="true"
          >Belépés</a
        >
        <a *appShowIfLoggedIn="true" role="menuitem" routerLink="/profile">Profilom</a>
        @if (showNotification()) {
          <button
            *appShowIfLoggedIn="true"
            aria-label="Értesítések"
            class="notification-button"
            type="button"
            (click)="onNotificationClick()"
          >
            <mat-icon svgIcon="pct-mdi-bell-outline" />
          </button>
        }
      </nav>
      <!-- mobile menu -->
      <div class="mobile-menu-wrapper">
        <div *appShowOnMobileOrTablet="'considerViewWidth'" id="mobile_menu_container">
          <button
            aria-label="Menü nyitása"
            id="mobile_menu_button"
            type="button"
            (click)="toggleMobileMenu()"
          >
            <img alt="" height="25" src="multimedia/header/hamburger_icon.webp" width="25" />
          </button>
          <nav
            aria-label="Főmenü mobil"
            id="nav_menu_mobile"
            role="navigation"
            [class.active]="isActive"
          >
            <button id="mobile_menu_close" type="button" (click)="toggleMobileMenu()">
              <mat-icon svgIcon="pct-mdi-close" />
            </button>

            <div class="subnav">
              <a
                *appHasAccess="'Admin'"
                class="subnavbtn"
                href="#"
                role="menuitem"
                tabindex="-1"
                [attr.data-isopen]="openedMobileSubmenu === 'admin'"
                (click)="changeMobileSubmenuState('admin', $event)"
              >
                <span class="mobile-menu-icon">
                  <mat-icon svgIcon="pct-mdi-shield-account-outline" />
                </span>
                <span>Admin</span>
                <mat-icon class="arrow" svgIcon="pct-mdi-chevron-left" />
              </a>
              <div
                class="subnav-content subnav-admin"
                [attr.data-isopen]="openedMobileSubmenu === 'admin'"
                [class.admin-height]="isAdmin()"
              >
                <a
                  *appHasAccess="'SuperAdmin'"
                  role="menuitem"
                  routerLink="/admin/admins"
                  (click)="toggleMobileMenu()"
                  >Adminok listája</a
                >
                <a role="menuitem" routerLink="/admin/users" (click)="toggleMobileMenu()"
                  >Regisztráltak listája</a
                >
                <ng-container *appHasAccess="'SuperAdmin'">
                  <a role="menuitem" routerLink="/admin/auditors" (click)="toggleMobileMenu()"
                    >Előadók listája</a
                  >
                  <a role="menuitem" routerLink="/admin/partners" (click)="toggleMobileMenu()"
                    >Partnerek listája</a
                  >
                  <a role="menuitem" routerLink="/admin/programs" (click)="toggleMobileMenu()"
                    >Események listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/workshop-applications"
                    (click)="toggleMobileMenu()"
                    >Kerekasztal-beszélgetésre jelentkezések listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/seminar-applications"
                    (click)="toggleMobileMenu()"
                    >Szemináriumra jelentkezések listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/exhibition-stands"
                    (click)="toggleMobileMenu()"
                    >Standok listája</a
                  >
                  <a role="menuitem" routerLink="/admin/players" (click)="toggleMobileMenu()"
                    >Játékosok listája</a
                  >
                  <a
                    role="menuitem"
                    routerLink="/admin/push-notifications"
                    (click)="toggleMobileMenu()"
                    >Értesítések listája</a
                  >
                  <a role="menuitem" routerLink="/admin/map" (click)="toggleMobileMenu()"
                    >Térkép szerkesztése</a
                  >
                  <a role="menuitem" routerLink="/admin/gala-dinner" (click)="toggleMobileMenu()"
                    >Gálavacsora szerkesztése</a
                  >
                </ng-container>
                <a role="menuitem" routerLink="/admin/qrcode-checker" (click)="toggleMobileMenu()"
                  >QR kód beolvasása</a
                >
              </div>
            </div>
            <div class="subnav">
              <a
                class="subnavbtn"
                href="#"
                role="menuitem"
                tabindex="-1"
                [attr.data-isopen]="openedMobileSubmenu === 'home'"
                (click)="changeMobileSubmenuState('home', $event)"
              >
                <span class="mobile-menu-icon">
                  <mat-icon svgIcon="pct-mdi-home-outline" />
                </span>
                <span>Kezdőoldal</span>
                <mat-icon class="arrow" svgIcon="pct-mdi-chevron-left" />
              </a>
              <div class="subnav-content" [attr.data-isopen]="openedMobileSubmenu === 'home'">
                <a href="#what-is-szebit" role="menuitem" tabindex="-1" (click)="toggleMobileMenu()"
                  >Mi a SZEBIT?</a
                >
                <a href="#the-host" role="menuitem" tabindex="-1" (click)="toggleMobileMenu()"
                  >A házigazda</a
                >
                <a href="#exhibitors" role="menuitem" tabindex="-1" (click)="toggleMobileMenu()"
                  >Kiállítók és Partnerek</a
                >
                <a href="#galleries" role="menuitem" tabindex="-1" (click)="toggleMobileMenu()"
                  >Galériák</a
                >
              </div>
            </div>
            <a
              class="subnavbtn"
              role="menuitem"
              routerLink="/auditors"
              (click)="toggleMobileMenu()"
            >
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-account-voice" />
              </span>
              <span>Előadók</span>
            </a>
            <a class="subnavbtn" href="#programs" role="menuitem" (click)="toggleMobileMenu()">
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-calendar-text-outline" />
              </span>
              <span>Programfüzet</span>
            </a>
            <!--<a class="subnavbtn" role="menuitem" routerLink="map" (click)="toggleMobileMenu()">
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-map-outline" />
              </span>
              <span>Térkép</span>
            </a>
            <a class="subnavbtn" role="menuitem" routerLink="game" (click)="toggleMobileMenu()">
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-format-list-checks" />
              </span>
              <span>Játék</span>
            </a>-->
            <a
              *appHasAccess="'VipGold'"
              class="subnavbtn"
              role="menuitem"
              routerLink="gala-dinner"
              (click)="toggleMobileMenu()"
            >
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-silverware" />
              </span>
              <span>Gálavacsora</span>
            </a>
            <a
              *appShowIfLoggedIn="false"
              class="subnavbtn"
              role="menuitem"
              routerLink="/registration"
              (click)="toggleMobileMenu()"
            >
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-account-plus-outline" />
              </span>
              <span>Regisztráció</span>
            </a>
            <a
              *appShowIfLoggedIn="false"
              class="subnavbtn"
              href="#"
              role="menuitem"
              routerLink="/login"
              skipLocationChange="true"
            >
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-login" />
              </span>
              <span>Belépés</span>
            </a>
            <a
              *appShowIfLoggedIn="true"
              class="subnavbtn"
              role="menuitem"
              routerLink="/profile"
              (click)="toggleMobileMenu()"
            >
              <span class="mobile-menu-icon">
                <mat-icon svgIcon="pct-mdi-account-outline" />
              </span>
              <span>Profilom</span>
            </a>
          </nav>
        </div>
        <!-- mobile notification -->
        @if (showNotification()) {
          <div *appShowOnMobileOrTablet>
            <button
              *appShowIfLoggedIn="true"
              aria-label="Értesítések"
              class="notification-button"
              type="button"
              (click)="onNotificationClick()"
            >
              <mat-icon svgIcon="pct-mdi-bell-outline" />
            </button>
          </div>
        }
      </div>
    </div>
  </div>
</header>
